import { LANGUAGE_EN } from '@home/_config/config';
import SingleSelect from '@home/components/SingleSelect';
import { getName } from '@home/utils/common';
import React, { useState } from 'react';
import { Button, Checkbox, Modal } from 'tea-component';
import { getLocale, useIntl } from 'umi';
import { ISelectOptionItemType } from '@home/components/SingleSelect/type';
import { FUNCOM_CARD_LIST } from '../../_config/config';
import './index.scss';
import OpinionsPreViewModal from '../OpinionsPreViewModal';

interface IOpinonsDownModalProps {
  visible: boolean;
  channelList: ISelectOptionItemType[];
  defaultChannelValue?: string;
  filter?: any;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const OpinonsDownModal = (props: IOpinonsDownModalProps) => {
  const { visible, setVisible, channelList, defaultChannelValue, filter } = props || {};

  // 获取所有卡片模块
  const defaultSelectCard = FUNCOM_CARD_LIST.map((item) => item.value);

  const [selectCard, setSelectCard] = useState<string[]>(defaultSelectCard);
  const [selectChannel, setSelectChannel] = useState(defaultChannelValue);
  const [previewVisible, setPreviewVisible] = useState(false);
  const { formatMessage } = useIntl();
  const isEn = getLocale() === LANGUAGE_EN;

  const onClose = () => {
    setVisible(false);
  };

  const selectClearAll = () => {
    if (selectCard?.length > 0) {
      setSelectCard([]);
    } else {
      setSelectCard(defaultSelectCard);
    }
  };

  return (
    <>
      <Modal
        className="dbh-studio-opinion-down-modal"
        visible={visible}
        onClose={onClose}
        size="l"
        caption={formatMessage({ id: 'metrics_setting_title' })}
      >
        <Modal.Body>
          <div className="dbh-studio-opinion-down-row">
            <div className="dbh-studio-opinion-down-row-lable">
              {formatMessage({ id: 'dbh_studio_funcom_down_metrics' })}
            </div>
            <div className="dbh-studio-opinion-down-row-content">
              <div
                className="dbh-studio-opinion-down-row-clear"
                onClick={selectClearAll}
              >
                {formatMessage({
                  id:
                    selectCard?.length > 0
                      ? 'dbh_studio_funcom_down_clear_all'
                      : 'dbh_studio_funcom_down_select_all',
                })}
              </div>
              <Checkbox.Group
                className="dbd-check-list down-group"
                value={selectCard}
                onChange={(value) => setSelectCard(value)}
              >
                {FUNCOM_CARD_LIST?.map((item) => {
                  const { nameEn, nameCn, value } = item;
                  return (
                    <Checkbox key={value} name={value}>
                      {getName(isEn, nameEn, nameCn)}
                    </Checkbox>
                  );
                })}
              </Checkbox.Group>
            </div>
          </div>
          {selectCard?.includes('officialAccountsOverview') && (
            <div className="dbh-studio-opinion-down-row">
              <div className="dbh-studio-opinion-down-row-lable">
                {formatMessage({
                  id: 'dbh_studio_funcom_down_official_accounts_channel',
                })}
              </div>
              <div className="dbh-studio-opinion-down-row-content">
                <SingleSelect
                  options={channelList}
                  value={selectChannel}
                  matchButtonWidth
                  searchable={false}
                  style={{ width: 200 }}
                  name={'Channel'}
                  onChange={setSelectChannel}
                />
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button type="primary" disabled={selectCard?.length === 0} onClick={() => setPreviewVisible(true)}>
            {formatMessage({ id: 'common_confirm' })}
          </Button>
          <Button type="weak" onClick={onClose}>
            {formatMessage({ id: 'common_cancel' })}
          </Button>
        </Modal.Footer>
      </Modal>
      {previewVisible && <OpinionsPreViewModal filter={filter} visible={previewVisible} selectCard={selectCard} setVisible={setPreviewVisible} />}
    </>
  );
};

export default OpinonsDownModal;
